module.exports = __webpack_public_path__ + "static/media/builtinv2-last section 1 1.28da28a6.png";